"use client"
import { GetPageByRouteQuery } from "apollo"
import React, { useEffect, useState } from "react"
import { baseIframeUrl, customerId, getBreadCrumbs } from "utils"

interface JourneyPlannerProps {
  data: GetPageByRouteQuery
  locale: "he" | "en" | "ar" | "ru"
}

const JourneyPlanner: React.FC<JourneyPlannerProps> = ({
  data,
  locale = "he",
}) => {
  const parsedData = data?.page?.properties || []
  // const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  const [iframeUrl, setIframeUrl] = useState("")

  useEffect(() => {
    // Only run on the client side
    if (typeof window !== "undefined") {
      const urlSearchParams = new URLSearchParams(window.location.search)

      // Create new URLSearchParams for iframe
      const iframeParams = new URLSearchParams()

      // Only add customerId if it's not already in the URL params
      if (!urlSearchParams.has("customerId")) {
        iframeParams.append("customerId", customerId)
      }
      // Copy all search params from the page URL to iframe URL
      urlSearchParams.forEach((value, key) => {
        iframeParams.append(key, value)
      })

      // Determine the correct base path
      const hasLines = urlSearchParams.get("lines") === "true"
      const basePath = hasLines
        ? baseIframeUrl.replace(/poi\/?$/, "lines/")
        : baseIframeUrl

      // Set the complete iframe URL
      setIframeUrl(`${basePath}${locale}?${iframeParams.toString()}`)
    }
  }, [])

  return (
    <>
      <iframe
        src={iframeUrl}
        title="Journey Planner"
        width="100%"
        height="800px"
        style={{ border: "none" }}
      />
    </>
  )
}

export default JourneyPlanner
